import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import '../tokens.css';

/* ------------------------------------------------------------------
   TechAssembly Landing Page — Serverless Port
   Goal: layout/layout, copy, CSS, and behaviour parity with
   Elixir techassembly.io landing_revised.html.heex + public.html.heex
   ------------------------------------------------------------------ */

const LogoSVG = ({ className = 'w-6 h-6' }: { className?: string }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 204.27 204.27" className={className} aria-label="TechAssembly Logo">
    <g fill="currentColor">
      <path d="M118.81,62.61a23,23,0,0,1-5,3.77,20.78,20.78,0,0,1-11.72,2.56,20.79,20.79,0,0,1-11.73-2.56,23,23,0,0,1-5-3.77L30.82,8.53A29,29,0,0,1,51.37,0,28.59,28.59,0,0,1,69.21,6.79l32.93,32,32.92-32A28.59,28.59,0,0,1,152.9,0a29,29,0,0,1,20.55,8.53Z" />
      <path d="M118.81,141.66a23,23,0,0,0-5-3.77,21.23,21.23,0,0,0-6.81-2.36,21.58,21.58,0,0,0-4.91-.2,21.65,21.65,0,0,0-4.92.2,21.23,21.23,0,0,0-6.81,2.36,23,23,0,0,0-5,3.77L30.82,195.74a29,29,0,0,0,20.55,8.53,28.54,28.54,0,0,0,17.84-6.79l32.93-32,32.92,32a28.54,28.54,0,0,0,17.84,6.79,29,29,0,0,0,20.55-8.53Z" />
      <path d="M141.66,85.46a23,23,0,0,0-3.77,5,21.23,21.23,0,0,0-2.36,6.81,21.65,21.65,0,0,0-.2,4.92,21.58,21.58,0,0,0,.2,4.91,21.23,21.23,0,0,0,2.36,6.81,23,23,0,0,0,3.77,5l54.08,54.64a29,29,0,0,0,8.53-20.55,28.54,28.54,0,0,0-6.79-17.84l-32-32.92,32-32.93a28.54,28.54,0,0,0,6.79-17.84,29,29,0,0,0-8.53-20.55Z" />
      <path d="M62.61,85.46a23,23,0,0,1,3.77,5,20.79,20.79,0,0,1,2.56,11.73,20.78,20.78,0,0,1-2.56,11.72,23,23,0,0,1-3.77,5L8.53,173.45A29,29,0,0,1,0,152.9a28.59,28.59,0,0,1,6.79-17.84l32-32.92-32-32.93A28.59,28.59,0,0,1,0,51.37,29,29,0,0,1,8.53,30.82Z" />
    </g>
    <g fill="currentColor" transform="translate(102.14, 102.14) scale(0.72) translate(-210, -216)">
      <path d="M 220.80 236.99 C218.02,235.63 215.50,234.78 213.16,234.41 L 213.15 234.41 C210.44,233.98 208.48,234.25 205.08,235.68 C200.73,237.40 195.46,240.74 188.92,245.91 C187.33,247.15 185.79,248.41 184.39,249.62 L 184.39 249.62 C182.68,251.06 180.89,252.62 179.02,254.28 C177.98,255.08 176.90,255.86 175.99,256.45 C174.05,257.70 171.86,259.46 171.11,260.36 C170.37,261.26 169.32,262.00 168.79,262.00 C168.26,262.00 169.55,259.64 171.64,256.75 C173.74,253.86 177.94,248.12 180.98,243.98 C183.60,240.41 185.87,236.94 187.74,233.68 L 187.74 233.68 C188.54,232.30 189.27,230.96 189.92,229.68 C191.70,226.16 192.86,223.02 193.43,220.02 C193.59,219.21 193.70,218.44 193.76,217.71 C193.83,216.88 193.85,216.06 193.83,215.24 L 193.83 215.24 C193.76,212.52 193.18,209.84 192.11,207.00 C191.79,206.15 191.33,205.12 190.75,203.96 C189.14,200.57 186.86,196.72 183.77,192.08 C174.29,177.85 173.73,176.94 174.16,176.51 C174.62,176.04 181.21,180.53 190.14,187.39 C195.35,191.40 200.77,194.55 205.20,196.29 C208.18,197.51 210.62,198.00 212.42,197.71 C217.37,196.90 222.62,194.31 229.75,188.84 C233.83,185.78 238.57,181.81 244.26,176.75 C247.81,173.59 251.04,171.00 251.43,171.00 C252.91,171.00 250.80,174.94 244.52,183.86 C241.98,187.36 239.76,190.50 237.86,193.36 C233.07,200.49 230.59,205.21 229.47,209.50 C228.42,213.06 228.26,216.25 228.86,219.50 C229.20,222.23 230.11,224.53 232.22,228.72 L 232.22 228.72 C232.28,228.84 232.34,228.96 232.40,229.08 C232.44,229.16 232.49,229.25 232.53,229.33 C234.61,233.39 237.79,238.75 239.68,241.38 C244.55,248.16 248.26,255.00 247.07,255.00 C246.52,255.00 244.59,253.73 242.78,252.19 C234.56,245.14 226.99,239.94 220.80,236.99 Z" />
    </g>
  </svg>
);

const WhatsAppIcon = ({ className = 'w-3.5 h-3.5' }: { className?: string }) => (
  <svg className={className} fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
  </svg>
);

const CheckIcon = () => (
  <svg className="w-3.5 h-3.5 text-status-success/60" fill="currentColor" viewBox="0 0 20 20">
    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
  </svg>
);

const ChevronDownIcon = ({ open }: { open?: boolean }) => (
  <svg className={`w-4 h-4 transition-transform duration-200 ${open ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
  </svg>
);

const SunIcon = ({ className = 'w-4 h-4' }: { className?: string }) => (
  <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z" />
  </svg>
);

const MoonIcon = ({ className = 'w-4 h-4' }: { className?: string }) => (
  <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z" />
  </svg>
);

const LinkedInIcon = ({ className = 'w-5 h-5' }: { className?: string }) => (
  <svg className={className} fill="currentColor" viewBox="0 0 24 24">
    <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
  </svg>
);

const XIcon = ({ className = 'w-5 h-5' }: { className?: string }) => (
  <svg className={className} fill="currentColor" viewBox="0 0 24 24">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
  </svg>
);

const FacebookIcon = ({ className = 'w-5 h-5' }: { className?: string }) => (
  <svg className={className} fill="currentColor" viewBox="0 0 24 24">
    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
  </svg>
);

const BlogIcon = ({ className = 'w-5 h-5' }: { className?: string }) => (
  <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z" />
  </svg>
);

const events = [
  { level: 'success', icon: '✓', label: 'Payment confirmed — ₦28,000', meta: 'Sales Order #TA-1041 · Lagos HQ', time: 'now' },
  { level: 'critical', icon: '!', label: 'Delivery unconfirmed — 16h overdue', meta: 'Dispatch #TA-1038 · Abuja branch', time: '2m' },
  { level: 'info', icon: '↓', label: 'Stock received — 20 units', meta: 'Silk blouse (size M) · Warehouse A', time: '5m' },
  { level: 'warning', icon: '?', label: 'Approval needed — inter-branch transfer', meta: 'Lagos → Abuja · 12 units', time: '9m' },
  { level: 'success', icon: '✓', label: 'Order fulfilled — Amara K.', meta: '2x Black Sneakers (Size 42)', time: '14m' },
  { level: 'critical', icon: '✕', label: 'Workflow stalled — approval step', meta: 'Expense ₦45,000 · Awaiting @admin', time: '18m' },
  { level: 'info', icon: '↓', label: 'QR check-in logged — Field agent', meta: 'Job #FO-229 · Ikeja site', time: '22m' },
  { level: 'success', icon: '✓', label: 'Invoice paid — ₦112,500', meta: 'Client: Bluechip Logistics', time: '26m' },
];

const eventColorClasses: Record<string, string> = {
  success: 'bg-status-success/10 text-status-success',
  critical: 'bg-red-500/10 text-red-500',
  warning: 'bg-amber-500/10 text-amber-600',
  info: 'bg-blue-500/10 text-blue-500',
};

const faqs = [
  { q: 'What kind of businesses use TechAssembly?', a: 'Retail chains with multiple branches, logistics and courier companies, field service operators, hospitality businesses, and any growing SME that needs to track orders, manage stock, record payments, and stay organised without enterprise software.' },
  { q: 'Do I need technical skills to set up?', a: "No. You create your workspace, add your catalog, invite your contacts, and you're operational. Most businesses are set up within an afternoon. No developers required." },
  { q: 'Can I manage multiple branches or locations?', a: 'Yes. Create a parent workspace for your HQ and child workspaces for each branch. The parent has full visibility across all branches. Each branch has its own catalog, forms, pages, and activity feed.' },
  { q: 'What are Pages and how are they different from Forms?', a: 'A Form collects one type of data — an order, a feedback submission, a registration. Submit it and it becomes an event in your ledger. A Page is a shareable mini-site that can combine multiple forms, images, videos, and links into one professional URL. Think of Forms as Google Forms and Pages as your Linktree — except both feed into the same operational system.' },
  { q: 'How does TechAssembly handle my financial records?', a: 'Every sale, payment, and expense is recorded as an immutable event in your ledger — timestamped, attributed to a person, and permanent. This gives you a clean, auditable trail of all financial activity. Your accountant gets structured records instead of a box of receipts.' },
  { q: 'How do payments and invoices work?', a: "You can create and send invoices from your dashboard. Customers pay via Paystack (card) or bank transfer. Payment events are recorded in your ledger so you always know who paid, when, and for what. We're building automatic invoice generation from orders — coming soon." },
  { q: 'Will there be automated workflows?', a: 'Yes. A visual workflow builder is in development — define triggers (order placed, form submitted, QR scanned) and chain actions (notify someone, request approval, update stock). During beta, the system records all your operational events so when workflows go live, they\'ll work with your existing data from day one.' },
  { q: 'Is TechAssembly free?', a: 'Yes. For the next 30 days, all core features are free. Some advanced outputs require Capacity, which you can top up to unlock more processing and operational scale as you use the platform.' },
];

export default function LandingPage() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [useCasesOpen, setUseCasesOpen] = useState(false);
  const [communityOpen, setCommunityOpen] = useState(false);
  const [profileOpen, setProfileOpen] = useState(false);
  const [cookieVisible, setCookieVisible] = useState(false);
  const [isDark, setIsDark] = useState(false);

  const mobileMenuRef = useRef<HTMLDivElement>(null);
  const toggleBtnRef = useRef<HTMLButtonElement>(null);
  const profileBtnRef = useRef<HTMLButtonElement>(null);
  const profileMenuRef = useRef<HTMLDivElement>(null);

  const currentUser = null; // TODO: wire to auth context when public users are supported

  useEffect(() => {
    document.title = "Know what's happening across every branch | TechAssembly";
    document.body.style.background = 'var(--surface-primary)';
    return () => { document.body.style.background = ''; };
  }, []);

  useEffect(() => {
    const saved = localStorage.getItem('ta-theme') || 'auto';
    const apply = (mode: string) => {
      const root = document.documentElement;
      if (mode === 'dark') {
        root.classList.add('dark');
        root.classList.remove('light');
        setIsDark(true);
      } else if (mode === 'light') {
        root.classList.remove('dark');
        root.classList.add('light');
        setIsDark(false);
      } else {
        if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
          root.classList.add('dark');
          root.classList.remove('light');
          setIsDark(true);
        } else {
          root.classList.remove('dark');
          root.classList.add('light');
          setIsDark(false);
        }
      }
    };
    apply(saved);
  }, []);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    if (!localStorage.getItem('cookie_consent')) {
      setCookieVisible(true);
    }
  }, []);

  useEffect(() => {
    const handler = (e: MouseEvent) => {
      const target = e.target as Node;
      if (
        mobileMenuRef.current &&
        toggleBtnRef.current &&
        !mobileMenuRef.current.contains(target) &&
        !toggleBtnRef.current.contains(target)
      ) {
        setMobileOpen(false);
      }
      if (
        profileMenuRef.current &&
        profileBtnRef.current &&
        !profileMenuRef.current.contains(target) &&
        !profileBtnRef.current.contains(target)
      ) {
        setProfileOpen(false);
      }
    };
    document.addEventListener('click', handler);
    return () => document.removeEventListener('click', handler);
  }, []);

  const acceptCookies = () => {
    localStorage.setItem('cookie_consent', 'accepted');
    setCookieVisible(false);
    try {
      // @ts-ignore
      if (typeof gtag === 'function') {
        // @ts-ignore
        gtag('consent', 'update', { analytics_storage: 'granted' });
      }
    } catch {}
  };

  const declineCookies = () => {
    localStorage.setItem('cookie_consent', 'declined');
    setCookieVisible(false);
  };

  const toggleTheme = () => {
    const root = document.documentElement;
    const next = root.classList.contains('dark') ? 'light' : 'dark';
    localStorage.setItem('ta-theme', next);
    if (next === 'dark') {
      root.classList.add('dark');
      root.classList.remove('light');
      setIsDark(true);
    } else {
      root.classList.remove('dark');
      root.classList.add('light');
      setIsDark(false);
    }
  };

  const AuthFlowLink = ({ children, className }: { children: React.ReactNode; className?: string }) => (
    <Link to="/login" className={className}>{children}</Link>
  );

  return (
    <div className="flex flex-col min-h-screen bg-surface-primary text-text-primary font-inter">
      {/* ---------- Navigation ---------- */}
      <nav
        id="navbar"
        className={`navbar fixed top-0 left-0 right-0 z-50 px-6 flex items-center ${scrolled ? 'scrolled' : ''}`}
      >
        <div className="w-full max-w-7xl mx-auto flex justify-between items-center">
          {/* Logo */}
          <a href="/" className="flex items-center space-x-2 group">
            <LogoSVG className="w-5 h-5 transition-transform duration-200 group-hover:scale-105" />
            <div className="flex items-center space-x-2">
              <span className="text-base font-semibold text-text-primary">TechAssembly</span>
              <span className="px-1.5 py-0.5 text-[0.625rem] font-semibold bg-brand-orange-subtle text-brand-orange rounded border border-brand-orange/15">
                Beta
              </span>
            </div>
          </a>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-1">
            <a href="/#how-it-works" className="nav-link">How It Works</a>

            {/* Use Cases Dropdown */}
            <div className="relative">
              <button
                onClick={() => setUseCasesOpen((v) => !v)}
                className="nav-link flex items-center space-x-1"
              >
                <span>Use Cases</span>
                <ChevronDownIcon open={useCasesOpen} />
              </button>
              {useCasesOpen && (
                <div className="absolute top-full left-0 mt-2 w-80 rounded-lg bg-surface-elevated border border-border-primary shadow-lg py-2 z-50">
                  <a href="/use-cases/retail" className="block px-4 py-2.5 hover:bg-surface-secondary transition-colors group">
                    <div className="flex items-center space-x-3">
                      <div className="flex-shrink-0 w-8 h-8 rounded-md bg-cta/10 flex items-center justify-center">
                        <svg className="w-4 h-4 text-cta" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                        </svg>
                      </div>
                      <div>
                        <p className="text-sm font-medium text-text-primary">Retail Operations</p>
                        <p className="text-xs text-text-tertiary">Multi-branch stock, sales & transfers</p>
                      </div>
                    </div>
                  </a>
                  <a href="/use-cases/logistics" className="block px-4 py-2.5 hover:bg-surface-secondary transition-colors group">
                    <div className="flex items-center space-x-3">
                      <div className="flex-shrink-0 w-8 h-8 rounded-md bg-cta/10 flex items-center justify-center">
                        <svg className="w-4 h-4 text-cta" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16V6a1 1 0 00-1-1H4a1 1 0 00-1 1v10a1 1 0 001 1h1m8-1a1 1 0 01-1 1H9m4-1V8a1 1 0 011-1h2.586a1 1 0 01.707.293l3.414 3.414a1 1 0 01.293.707V16a1 1 0 01-1 1h-1m-6-1a1 1 0 001 1h1M5 17a2 2 0 104 0m-4 0a2 2 0 114 0m6 0a2 2 0 104 0m-4 0a2 2 0 114 0" />
                        </svg>
                      </div>
                      <div>
                        <p className="text-sm font-medium text-text-primary">Logistics & Distribution</p>
                        <p className="text-xs text-text-tertiary">Dispatch, delivery & fleet tracking</p>
                      </div>
                    </div>
                  </a>
                  <a href="/use-cases/field-operations" className="block px-4 py-2.5 hover:bg-surface-secondary transition-colors group">
                    <div className="flex items-center space-x-3">
                      <div className="flex-shrink-0 w-8 h-8 rounded-md bg-cta/10 flex items-center justify-center">
                        <svg className="w-4 h-4 text-cta" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                        </svg>
                      </div>
                      <div>
                        <p className="text-sm font-medium text-text-primary">Field Operations</p>
                        <p className="text-xs text-text-tertiary">QR check-ins, mobile forms & task tracking</p>
                      </div>
                    </div>
                  </a>
                </div>
              )}
            </div>

            <a href="/pricing" className="nav-link">Pricing</a>
            <a href="/company" className="nav-link">Company</a>

            {/* Community Dropdown */}
            <div className="relative">
              <button
                onClick={() => setCommunityOpen((v) => !v)}
                className="nav-link flex items-center space-x-1"
              >
                <span>Community</span>
                <ChevronDownIcon open={communityOpen} />
              </button>
              {communityOpen && (
                <div className="absolute top-full left-0 mt-2 w-80 rounded-lg bg-surface-elevated border border-border-primary shadow-lg py-2 z-50">
                  <a href="https://www.linkedin.com/company/techassembly-co" target="_blank" rel="noreferrer" className="block px-4 py-3 hover:bg-surface-secondary transition-colors group">
                    <div className="flex items-start space-x-4">
                      <div className="flex-shrink-0 w-10 h-10 rounded-lg bg-blue-50 dark:bg-blue-950/30 flex items-center justify-center text-blue-600 group-hover:scale-110 transition-transform">
                        <LinkedInIcon className="w-5 h-5" />
                      </div>
                      <div>
                        <h4 className="text-sm font-semibold text-text-primary">LinkedIn</h4>
                        <p className="text-xs text-text-tertiary mt-0.5">Join our community on LinkedIn</p>
                      </div>
                    </div>
                  </a>
                  <a href="https://x.com/TechAssemblyCo" target="_blank" rel="noreferrer" className="block px-4 py-3 hover:bg-surface-secondary transition-colors group">
                    <div className="flex items-start space-x-4">
                      <div className="flex-shrink-0 w-10 h-10 rounded-lg bg-slate-100 dark:bg-slate-800 flex items-center justify-center text-text-primary group-hover:scale-110 transition-transform">
                        <XIcon className="w-5 h-5" />
                      </div>
                      <div>
                        <h4 className="text-sm font-semibold text-text-primary">X</h4>
                        <p className="text-xs text-text-tertiary mt-0.5">Follow us on X</p>
                      </div>
                    </div>
                  </a>
                  <a href="https://facebook.com/TechAssemblyCo" target="_blank" rel="noreferrer" className="block px-4 py-3 hover:bg-surface-secondary transition-colors group">
                    <div className="flex items-start space-x-4">
                      <div className="flex-shrink-0 w-10 h-10 rounded-lg bg-blue-50 dark:bg-blue-950/30 flex items-center justify-center text-blue-600 group-hover:scale-110 transition-transform">
                        <FacebookIcon className="w-5 h-5" />
                      </div>
                      <div>
                        <h4 className="text-sm font-semibold text-text-primary">Facebook</h4>
                        <p className="text-xs text-text-tertiary mt-0.5">Join the discussion</p>
                      </div>
                    </div>
                  </a>
                  <a href="https://blog.techassembly.io" target="_blank" rel="noreferrer" className="block px-4 py-3 hover:bg-surface-secondary transition-colors group">
                    <div className="flex items-start space-x-4">
                      <div className="flex-shrink-0 w-10 h-10 rounded-lg bg-indigo-50 dark:bg-indigo-950/30 flex items-center justify-center text-indigo-600 group-hover:scale-110 transition-transform">
                        <BlogIcon className="w-5 h-5" />
                      </div>
                      <div>
                        <h4 className="text-sm font-semibold text-text-primary">Blog</h4>
                        <p className="text-xs text-text-tertiary mt-0.5">Read our latest insights</p>
                      </div>
                    </div>
                  </a>
                </div>
              )}
            </div>

            <a href="/#faqs" className="nav-link">FAQs</a>

            {/* Theme Toggle */}
            <button
              onClick={toggleTheme}
              className="theme-toggle-btn nav-link flex items-center gap-1.5"
              title="Switch theme"
            >
              <SunIcon className={`w-4 h-4 ${isDark ? 'block' : 'hidden'}`} />
              <MoonIcon className={`w-4 h-4 ${isDark ? 'hidden' : 'block'}`} />
              <span className="theme-label text-xs font-medium">Theme</span>
            </button>

            {currentUser ? (
              <div className="relative ml-3">
                <button
                  ref={profileBtnRef}
                  onClick={() => setProfileOpen((v) => !v)}
                  className="nav-link flex items-center space-x-1.5"
                  title="Account & settings"
                >
                  <svg className="w-5 h-5 text-text-secondary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.066 2.573c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.573 1.066c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.066-2.573c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                  <svg className={`w-3.5 h-3.5 text-text-tertiary transition-transform duration-200 ${profileOpen ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                  </svg>
                </button>
                {profileOpen && (
                  <div ref={profileMenuRef} className="profile-menu absolute right-0 mt-2 w-56 rounded-xl py-2 z-50">
                    <Link to="/dashboard" className="block px-4 py-2.5 text-sm text-text-secondary hover:bg-accent-subtle transition-colors">
                      <div className="flex items-center space-x-3">
                        <BlogIcon className="w-4 h-4" />
                        <span>Work Feed</span>
                      </div>
                    </Link>
                    <Link to="/command-centre" className="block px-4 py-2.5 text-sm text-text-secondary hover:bg-accent-subtle transition-colors">
                      <div className="flex items-center space-x-3">
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                        </svg>
                        <span>Command Centre</span>
                      </div>
                    </Link>
                    <Link to="/settings" className="block px-4 py-2.5 text-sm text-text-secondary hover:bg-accent-subtle transition-colors">
                      <div className="flex items-center space-x-3">
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.066 2.573c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.573 1.066c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.066-2.573c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                        </svg>
                        <span>Settings</span>
                      </div>
                    </Link>
                  </div>
                )}
              </div>
            ) : (
              <div className="flex items-center space-x-2 ml-6">
                <AuthFlowLink className="nav-link">Login</AuthFlowLink>
                <AuthFlowLink className="px-4 py-1.5 bg-cta hover:bg-cta-hover text-cta-text text-[0.8125rem] font-semibold rounded-md transition shadow-sm">
                  Create Profile
                </AuthFlowLink>
              </div>
            )}
          </div>

          {/* Mobile Menu Button */}
          <button
            ref={toggleBtnRef}
            onClick={() => setMobileOpen((v) => !v)}
            className="md:hidden p-2 rounded-lg text-text-secondary hover:bg-surface-secondary transition-colors"
          >
            <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16m-7 6h7" />
            </svg>
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileOpen && (
          <div
            ref={mobileMenuRef}
            className="mobile-menu md:hidden absolute top-full left-4 right-4 mt-2 rounded-xl overflow-hidden"
          >
            <div className="p-4 space-y-2">
              <a href="/pricing" className="nav-link block">Pricing</a>
              <a href="/#how-it-works" className="nav-link block">How It Works</a>
              <a href="/company" className="nav-link block">Company</a>
              <a href="/#faqs" className="nav-link block">FAQs</a>

              <div className="border-t border-border-primary pt-3 mt-3">
                <p className="px-3 text-xs font-semibold text-text-tertiary uppercase tracking-wider mb-2">Use Cases</p>
                <a href="/use-cases/retail" className="nav-link block">Retail Operations</a>
                <a href="/use-cases/logistics" className="nav-link block">Logistics & Distribution</a>
                <a href="/use-cases/field-operations" className="nav-link block">Field Operations</a>
              </div>

              <div className="border-t border-border-primary pt-3 mt-3">
                <p className="px-3 text-xs font-semibold text-text-tertiary uppercase tracking-wider mb-2">Community</p>
                <a href="https://www.linkedin.com/company/techassembly-co" target="_blank" rel="noreferrer" className="nav-link flex items-center space-x-3">
                  <LinkedInIcon className="w-5 h-5 text-blue-600" />
                  <span>LinkedIn</span>
                </a>
                <a href="https://x.com/TechAssemblyCo" target="_blank" rel="noreferrer" className="nav-link flex items-center space-x-3">
                  <XIcon className="w-5 h-5 text-slate-700 dark:text-slate-300" />
                  <span>X</span>
                </a>
                <a href="https://facebook.com/TechAssemblyCo" target="_blank" rel="noreferrer" className="nav-link flex items-center space-x-3">
                  <FacebookIcon className="w-5 h-5 text-blue-600" />
                  <span>Facebook</span>
                </a>
                <a href="https://blog.techassembly.io" target="_blank" rel="noreferrer" className="nav-link flex items-center space-x-3">
                  <BlogIcon className="w-5 h-5 text-indigo-600" />
                  <span>Blog</span>
                </a>
              </div>

              <div className="border-t border-border-primary pt-3 mt-3">
                <button onClick={toggleTheme} className="theme-toggle-btn nav-link flex items-center space-x-3 w-full" title="Switch theme">
                  <SunIcon className={`w-5 h-5 ${isDark ? 'block text-amber-400' : 'hidden'}`} />
                  <MoonIcon className={`w-5 h-5 ${isDark ? 'hidden' : 'block text-slate-500'}`} />
                  <span className="theme-label text-sm font-medium">Theme</span>
                </button>
              </div>

              {currentUser ? (
                <>
                  <hr className="border-border-primary my-3" />
                  <Link to="/dashboard" className="nav-link block">Home</Link>
                  <a href="/logout" className="nav-link block text-red-600">Logout</a>
                </>
              ) : (
                <>
                  <hr className="border-border-primary my-3" />
                  <AuthFlowLink className="nav-link block">Login</AuthFlowLink>
                  <AuthFlowLink className="btn-primary block text-center rounded-md">Join Beta</AuthFlowLink>
                </>
              )}
            </div>
          </div>
        )}
      </nav>

      {/* ---------- Main Content ---------- */}
      <div className="pt-14">
        <main className="flex-1">
          <div className="bg-surface-primary">
            {/* Hero Section */}
            <section className="relative px-6 pt-12 pb-16 lg:pt-0 lg:pb-0 lg:min-h-screen lg:flex lg:items-center overflow-hidden">
              <div className="absolute top-0 left-1/4 w-96 h-96 bg-blue-500/10 dark:bg-blue-500/5 rounded-full blur-3xl pointer-events-none" />
              <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-purple-500/10 dark:bg-purple-500/5 rounded-full blur-3xl pointer-events-none" />

              <div className="max-w-6xl mx-auto w-full relative z-10">
                <div className="grid lg:grid-cols-[1fr_340px] xl:grid-cols-[1fr_360px] gap-12 xl:gap-20 items-center">
                  {/* Left: Copy */}
                  <div className="flex flex-col items-start">
                    <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-brand-orange/20 bg-brand-orange-subtle text-sm font-medium text-brand-orange mb-8">
                      <span className="w-2 h-2 rounded-full bg-brand-orange animate-pulse" />
                      For multi-location, inventory-heavy businesses
                    </div>

                    <h1 className="text-5xl sm:text-6xl lg:text-6xl xl:text-7xl font-black tracking-tight text-text-primary mb-6 leading-[1.06]">
                      Know what&apos;s happening<br />
                      <span className="text-accent">across every branch.</span>
                    </h1>

                    <p className="text-base md:text-lg text-text-secondary mb-8 max-w-lg leading-relaxed">
                      TechAssembly connects your orders, stock, payments and team activity into one operational workspace, so every sale becomes visible, traceable and actionable.
                    </p>

                    <div className="flex flex-col sm:flex-row items-start gap-3 mb-8">
                      <AuthFlowLink className="px-6 py-3 bg-cta hover:bg-cta-hover text-cta-text font-semibold rounded-md text-sm transition shadow-sm">
                        Create your workspace
                      </AuthFlowLink>
                      <a href="#how-it-works" className="px-6 py-3 bg-surface-secondary hover:bg-surface-elevated text-text-primary font-semibold rounded-md text-sm transition border border-border-primary">
                        See how it works
                      </a>
                    </div>

                    <div className="flex flex-wrap items-center gap-4 text-xs text-text-tertiary/70 tracking-wide mb-8">
                      <span className="flex items-center gap-1.5"><CheckIcon /> Free to start</span>
                      <span className="w-1 h-1 rounded-full bg-text-tertiary/30" />
                      <span className="flex items-center gap-1.5"><CheckIcon /> No credit card</span>
                      <span className="w-1 h-1 rounded-full bg-text-tertiary/30" />
                      <span className="flex items-center gap-1.5"><CheckIcon /> Live in minutes</span>
                    </div>

                    {/* WhatsApp hint */}
                    <a href="#whatsapp-automation" className="inline-flex items-center gap-2.5 px-4 py-2 rounded-full border border-brand-orange/25 bg-brand-orange-subtle hover:border-brand-orange/50 transition-colors group">
                      <span className="flex items-center gap-1.5 text-xs font-semibold text-brand-orange">
                        <WhatsAppIcon className="w-3.5 h-3.5" />
                        WhatsApp automation
                      </span>
                      <span className="text-xs text-text-tertiary">Your number working 24/7</span>
                      <svg className="w-3.5 h-3.5 text-brand-orange group-hover:translate-y-0.5 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                      </svg>
                    </a>
                  </div>

                  {/* Right: Live feed */}
                  <div className="w-full lg:py-12">
                    <div className="rounded-xl border border-border-primary bg-surface-elevated overflow-hidden shadow-sm">
                      <div className="flex items-center justify-between px-4 py-3 border-b border-border-primary bg-surface-secondary">
                        <span className="text-[10px] font-semibold tracking-widest text-text-tertiary uppercase">Live Feed</span>
                        <span className="flex items-center gap-1.5 text-[10px] font-semibold text-status-success">
                          <span className="w-1.5 h-1.5 rounded-full bg-status-success animate-pulse" />
                          Live
                        </span>
                      </div>

                      <div className="relative overflow-hidden" style={{ height: 300 }}>
                        <div className="feed-scroll-track absolute inset-x-0 top-0 flex flex-col">
                          {[...events, ...events].map((event, i) => (
                            <div key={i} className="flex items-start gap-3 px-4 py-3 border-b border-border-primary last:border-0">
                              <span className={`flex-shrink-0 w-6 h-6 rounded-md flex items-center justify-center text-[11px] font-bold mt-0.5 ${eventColorClasses[event.level]}`}>
                                {event.icon}
                              </span>
                              <div className="flex-1 min-w-0">
                                <p className="text-xs font-medium text-text-primary leading-snug truncate">{event.label}</p>
                                <p className="text-[10px] text-text-tertiary mt-0.5 truncate">{event.meta}</p>
                              </div>
                              <span className="text-[10px] text-text-tertiary flex-shrink-0 pt-0.5">{event.time}</span>
                            </div>
                          ))}
                        </div>
                      </div>

                      <div className="flex items-center gap-2 px-4 py-2.5 border-t border-border-primary bg-surface-secondary">
                        <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-brand-orange-subtle text-brand-orange text-[10px] font-semibold">
                          Swift Stores
                        </span>
                        <span className="text-[10px] text-text-tertiary">All branches · 6 events today</span>
                        <span className="inline-flex items-center gap-1.5 ml-auto text-text-tertiary">
                          <LogoSVG className="w-3 h-3 flex-shrink-0" />
                        </span>
                      </div>
                    </div>

                    <style>{`
                      .feed-scroll-track {
                        animation: feedScroll 20s linear infinite;
                      }
                      @keyframes feedScroll {
                        0% { transform: translateY(0); }
                        100% { transform: translateY(-50%); }
                      }
                      @media (prefers-reduced-motion: reduce) {
                        .feed-scroll-track { animation: none; }
                      }
                    `}</style>
                  </div>
                </div>
              </div>
            </section>

            {/* Problem Section */}
            <section className="py-24 bg-surface-secondary border-t border-border-primary">
              <div className="container mx-auto px-6 max-w-6xl">
                <div className="text-center mb-16">
                  <h2 className="text-3xl md:text-5xl font-extrabold text-text-primary mb-5 tracking-tight">
                    Your business is running.<br />But you cannot see it.
                  </h2>
                  <p className="text-lg text-text-tertiary font-medium max-w-2xl mx-auto">
                    Most businesses operate on WhatsApp messages, spreadsheets, and scattered tools.
                  </p>
                </div>

                <div className="grid md:grid-cols-2 gap-16 items-start max-w-5xl mx-auto mb-16">
                  <div>
                    <p className="text-xs font-semibold uppercase tracking-widest text-text-tertiary mb-5">Which means</p>
                    <ul className="space-y-4">
                      {[
                        'Orders get missed or delayed with no paper trail',
                        "Approvals stall in someone's inbox or unread chat",
                        'Stock counts are always a guess, never a fact',
                      ].map((text, i) => (
                        <li key={i} className="flex items-start gap-3">
                          <span className="mt-1 w-5 h-5 rounded-full bg-red-500/10 flex items-center justify-center flex-shrink-0">
                            <span className="w-1.5 h-1.5 rounded-full bg-red-500" />
                          </span>
                          <span className="text-base text-text-secondary">{text}</span>
                        </li>
                      ))}
                    </ul>
                  </div>

                  <div className="flex flex-col justify-center">
                    <div className="rounded-2xl border p-8" style={{ background: 'linear-gradient(135deg, var(--surface-elevated), var(--surface-secondary))', borderColor: 'var(--border-primary)' }}>
                      <p className="text-lg md:text-xl font-bold text-text-primary leading-snug mb-4">
                        You are not running a system.
                      </p>
                      <p className="text-2xl md:text-3xl font-black text-accent leading-tight">
                        You are reacting to messages.
                      </p>
                      <div className="mt-6 pt-6 border-t border-border-primary">
                        <p className="text-sm text-text-tertiary leading-relaxed">
                          Every growing business hits a point where chat-based coordination becomes the ceiling — not the tool. That ceiling is now.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Event type cards */}
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-10">
                  {[
                    { icon: '→', title: 'Order placed', sub: 'tracked, auto-handled' },
                    { icon: '$', title: 'Payment received', sub: 'verified, logged' },
                    { icon: '▪', title: 'Stock moves', sub: 'reserved, transferred' },
                    { icon: '✓', title: 'Delivery confirmed', sub: 'audit trail, closed' },
                  ].map((card, i) => (
                    <div key={i} className="rounded-xl border p-5 text-center" style={{ background: 'var(--surface-elevated)', borderColor: 'var(--border-primary)' }}>
                      <div className="text-2xl mb-2">{card.icon}</div>
                      <p className="text-sm font-semibold text-text-primary">{card.title}</p>
                      <p className="text-xs text-text-tertiary mt-1">{card.sub}</p>
                    </div>
                  ))}
                </div>

                <div className="flex flex-col sm:flex-row items-center justify-center gap-6">
                  <div className="flex items-center gap-3 px-5 py-3 rounded-xl border" style={{ background: 'var(--surface-elevated)', borderColor: 'var(--border-primary)' }}>
                    <span className="text-sm font-medium text-text-secondary">WhatsApp thread</span>
                    <svg className="w-4 h-4 text-text-tertiary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 7l5 5m0 0l-5 5m5-5H6" />
                    </svg>
                    <span className="text-sm font-bold text-accent">Structured operational event</span>
                  </div>
                </div>
              </div>
            </section>

            {/* Proof Section */}
            <section className="py-20 bg-surface-secondary border-t border-border-primary">
              <div className="container mx-auto px-6 max-w-6xl">
                <div className="text-center mb-12">
                  <span className="text-xs font-semibold uppercase tracking-widest text-accent mb-3 block">
                    Built from operating experience
                  </span>
                  <p className="text-base text-text-secondary max-w-lg mx-auto">
                    TechAssembly was shaped at 504 Yard, where checkout events now update inventory, payments, and a live operational ledger. The product is live. We are still proving repeat usage and paid conversion — and we state that honestly.
                  </p>
                </div>

                <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-6">
                  {[
                    { img: '/images/p-logo-next-hei.png', alt: 'Next HEI — European Institute of Innovation and Technology', text: 'Initiative of the European Institute of Innovation and Technology' },
                    { img: '/images/p-logo-cloudflare.svg', alt: 'Cloudflare Enterprise Startup Program', text: 'Enterprise Startup Program' },
                    { img: '/images/p-logo-aws.svg', alt: 'AWS Activate for Startups', text: 'Activate for Startups' },
                    { img: '/images/p-logo-auth0.svg', alt: 'Auth0 Startup Program', text: 'Startup Program' },
                    { img: '/images/p-logo-notion.svg', alt: 'Notion for Startups', text: 'for Startups' },
                    { img: '/images/p-logo-f6s.svg', alt: 'F6S Top Startup', text: 'Top Startup — March & April 2026' },
                  ].map((partner, i) => (
                    <div key={i} className="rounded-2xl border border-border-primary bg-surface-elevated px-4 py-6 text-center transition-all duration-300 hover:bg-surface-primary">
                      <div className="mb-3 flex h-10 items-center justify-center rounded-lg bg-white/80 dark:bg-white/90 px-3 py-1">
                        <img src={partner.img} alt={partner.alt} className="h-7 w-auto object-contain transition-opacity duration-300 hover:opacity-100 brightness-0 dark:brightness-100" loading="lazy" />
                      </div>
                      <p className="text-[11px] leading-relaxed text-text-tertiary">{partner.text}</p>
                    </div>
                  ))}
                </div>

                {/* Meta Verified row */}
                <div className="mt-10 flex justify-center">
                  <div className="inline-flex items-center gap-2.5 rounded-full border border-[#0081fb]/20 bg-[#0081fb]/5 px-5 py-2.5">
                    <img src="/images/p-logo-meta.svg" alt="Meta" className="h-5 w-5 opacity-80" loading="lazy" />
                    <span className="text-sm font-semibold text-[#0081fb]">Meta</span>
                    <span className="text-sm text-text-tertiary">Verified Tech Provider</span>
                  </div>
                </div>
              </div>
            </section>

            {/* What You Get */}
            <section className="py-20 bg-surface-primary border-t border-border-primary">
              <div className="container mx-auto px-6 max-w-6xl">
                <div className="text-center mb-12">
                  <p className="text-xs font-semibold uppercase tracking-widest text-accent mb-3">The product</p>
                  <h2 className="text-2xl md:text-3xl font-extrabold text-text-primary tracking-tight">
                    From storefront to operational record.
                  </h2>
                </div>
                <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-10">
                  {[
                    {
                      icon: 'M13 10V3L4 14h7v7l9-11h-7z',
                      title: '01. Storefront',
                      text: 'Publish your branded storefront where customers browse, order, and request in one place.',
                    },
                    {
                      icon: 'M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z',
                      title: '02. Structured input',
                      text: 'Capture orders and requests through a single, structured input instead of scattered chats and calls.',
                    },
                    {
                      icon: 'M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7',
                      title: '03. Inventory & fulfilment',
                      text: 'Track products, inventory, and fulfilment across branches so stock counts are facts, not guesses.',
                    },
                    {
                      icon: 'M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2',
                      title: '04. Connected ledger',
                      text: 'Keep checkout events tied to inventory, payments, and a live operational ledger for a clean audit trail.',
                    },
                  ].map((card, i) => (
                    <div
                      key={i}
                      className="group relative overflow-hidden rounded-xl p-8 border border-accent/20 transition-all duration-300 hover:shadow-lg hover:shadow-accent/5"
                      style={i % 2 === 1 ? { background: 'linear-gradient(135deg, rgba(37,99,235,0.08), rgba(37,99,235,0.02))' } : undefined}
                    >
                      {i % 2 === 0 && <div className="absolute inset-0 bg-gradient-to-br from-accent/[0.08] to-accent/[0.02] dark:from-accent/[0.15] dark:to-accent/[0.05]" />}
                      <div className="relative z-10">
                        <div className="w-14 h-14 rounded-xl bg-brand-orange flex items-center justify-center mb-6 shadow-sm transition-transform duration-300 group-hover:scale-105">
                          <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d={card.icon} />
                          </svg>
                        </div>
                        <h3 className="text-xl font-bold text-text-primary mb-3">{card.title}</h3>
                        <p className="text-text-secondary leading-relaxed">{card.text}</p>
                      </div>
                    </div>
                  ))}
                </div>

                <div className="text-center">
                  <AuthFlowLink className="inline-flex items-center px-6 py-3 bg-cta hover:bg-cta-hover text-cta-text font-semibold rounded-md text-sm transition shadow-sm">
                    Create your workspace
                  </AuthFlowLink>
                </div>
              </div>
            </section>

            {/* How It Works */}
            <section id="how-it-works" className="py-24 bg-surface-secondary border-t border-border-primary">
              <div className="container mx-auto px-6 max-w-6xl">
                <div className="text-center mb-20">
                  <h2 className="text-3xl md:text-5xl font-extrabold text-text-primary mb-4 tracking-tight">
                    Set up once. Run forever.
                  </h2>
                  <p className="text-base md:text-lg text-text-tertiary font-medium">
                    No implementation project. No consultants.
                  </p>
                </div>

                <div className="space-y-20">
                  {/* Step 1 */}
                  <div className="grid md:grid-cols-2 gap-16 items-center">
                    <div>
                      <div className="inline-flex items-center gap-3 mb-6">
                        <span className="flex items-center justify-center w-12 h-12 rounded-md bg-brand-orange text-white font-bold text-lg shadow-sm">01</span>
                        <div className="h-px flex-1 bg-border-primary" />
                      </div>
                      <h3 className="text-3xl font-bold text-text-primary mb-4">Create your workspace</h3>
                      <p className="text-lg text-text-secondary leading-relaxed">
                        Add your products, services, and branch locations. Your business structure goes live instantly — a credible link to share with customers, suppliers, and staff.
                      </p>
                    </div>
                    <div className="rounded-lg overflow-hidden border border-border-primary shadow-sm">
                      <StepSVG step={0} />
                    </div>
                  </div>

                  {/* Step 2 */}
                  <div className="grid md:grid-cols-2 gap-16 items-center">
                    <div className="rounded-lg overflow-hidden border border-border-primary shadow-sm md:order-first order-last">
                      <StepSVG step={1} />
                    </div>
                    <div>
                      <div className="inline-flex items-center gap-3 mb-6">
                        <span className="flex items-center justify-center w-12 h-12 rounded-md bg-brand-orange text-white font-bold text-lg shadow-sm">02</span>
                        <div className="h-px flex-1 bg-border-primary" />
                      </div>
                      <h3 className="text-3xl font-bold text-text-primary mb-4">Collect and share everything</h3>
                      <p className="text-lg text-text-secondary leading-relaxed mb-4">
                        Create forms for orders, applications, feedback — any structured input your business needs. Build shareable pages that combine your catalog, forms, images, and links into one professional endpoint.
                      </p>
                      <p className="text-sm font-medium text-accent">
                        Every submission becomes a traceable event in your ledger.
                      </p>
                    </div>
                  </div>

                  {/* Step 3 */}
                  <div className="grid md:grid-cols-2 gap-16 items-center">
                    <div>
                      <div className="inline-flex items-center gap-3 mb-6">
                        <span className="flex items-center justify-center w-12 h-12 rounded-md bg-brand-orange text-white font-bold text-lg shadow-sm">03</span>
                        <div className="h-px flex-1 bg-border-primary" />
                      </div>
                      <h3 className="text-3xl font-bold text-text-primary mb-4">See everything, decide fast</h3>
                      <p className="text-lg text-text-secondary leading-relaxed">
                        Every sale, payment, stock movement, and expense shows up in your feed the moment it happens. Signals flag what needs attention. You see what is moving, what is blocked, and what needs your decision — right now.
                      </p>
                    </div>
                    <div className="rounded-lg overflow-hidden border border-border-primary shadow-sm">
                      <StepSVG step={2} />
                    </div>
                  </div>
                </div>

                <div className="text-center mt-16">
                  <AuthFlowLink className="inline-flex items-center px-6 py-3 bg-cta hover:bg-cta-hover text-cta-text font-semibold rounded-md text-sm transition shadow-sm">
                    Get started free — setup takes minutes
                  </AuthFlowLink>
                </div>
              </div>
            </section>

            {/* WhatsApp Automation Section */}
            <section id="whatsapp-automation" className="py-20 bg-surface-primary border-t border-border-primary">
              <div className="container mx-auto px-6 max-w-5xl">
                <div className="grid md:grid-cols-2 gap-12 items-center">
                  <div>
                    <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-emerald-500/20 bg-emerald-500/8 dark:bg-emerald-950/20 text-xs font-semibold text-emerald-600 dark:text-emerald-400 mb-6">
                      <WhatsAppIcon className="w-4 h-4" />
                      WhatsApp automation
                    </div>
                    <h2 className="text-2xl md:text-3xl font-extrabold text-text-primary mb-4 tracking-tight">
                      Your number, working 24/7.
                    </h2>
                    <p className="text-base text-text-secondary leading-relaxed mb-6">
                      Connect your existing WhatsApp Business number. Customers keep messaging the same number they always have — TechAssembly captures orders, sends payment links, and replies with receipts automatically.
                    </p>
                    <ul className="space-y-3 text-sm text-text-secondary">
                      {[
                        'Incoming messages become structured orders',
                        'Payment links sent automatically on WhatsApp',
                        'Receipts delivered to customer after payment clears',
                        'Stock validated before confirming availability',
                      ].map((item, i) => (
                        <li key={i} className="flex items-start gap-2">
                          <svg className="w-4 h-4 text-emerald-500 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                          </svg>
                          {item}
                        </li>
                      ))}
                    </ul>
                  </div>

                  <div className="bg-emerald-50/50 dark:bg-emerald-950/10 border border-emerald-200/40 dark:border-emerald-900/30 rounded-2xl p-5">
                    <div className="flex items-center gap-2 mb-4">
                      <div className="w-8 h-8 rounded-full bg-emerald-500 flex items-center justify-center">
                        <WhatsAppIcon className="w-4 h-4 text-white" />
                      </div>
                      <span className="text-sm font-semibold text-text-primary">Customer chat</span>
                    </div>
                    <div className="space-y-2.5">
                      <div className="bg-white dark:bg-gray-800 rounded-lg rounded-tl-none p-3 text-xs text-text-secondary max-w-[80%] shadow-sm">
                        &quot;I want 2 pairs of the black sneakers, size 42&quot;
                      </div>
                      <div className="bg-emerald-100 dark:bg-emerald-900/40 rounded-lg rounded-tr-none p-3 text-xs text-text-secondary max-w-[80%] ml-auto shadow-sm">
                        <p className="font-semibold text-text-primary mb-1">Order confirmed</p>
                        <p>2x Black Sneakers (Size 42) — ₦36,000</p>
                        <p className="mt-1.5 text-emerald-700 dark:text-emerald-300 font-medium">Pay here: pay.techassembly.io/ord-1043</p>
                      </div>
                      <div className="bg-white dark:bg-gray-800 rounded-lg rounded-tl-none p-3 text-xs text-text-secondary max-w-[80%] shadow-sm">
                        &quot;Done, I just paid&quot;
                      </div>
                      <div className="bg-emerald-100 dark:bg-emerald-900/40 rounded-lg rounded-tr-none p-3 text-xs text-text-secondary max-w-[80%] ml-auto shadow-sm">
                        <p className="font-semibold text-text-primary mb-1">Payment received ✓</p>
                        <p>₦36,000 confirmed. Your order is being prepared.</p>
                        <p className="mt-1 text-text-tertiary">Receipt: rcpt.techassembly.io/r-1043</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            {/* Use Cases */}
            <section className="py-20 bg-surface-secondary border-t border-border-primary">
              <div className="container mx-auto px-6 max-w-6xl">
                <div className="text-center mb-14">
                  <h2 className="text-3xl md:text-5xl font-extrabold text-text-primary mb-4 tracking-tight">
                    Built for businesses with work happening in more than one place.
                  </h2>
                  <p className="text-base md:text-lg text-text-tertiary font-medium max-w-2xl mx-auto">
                    Retail chains, electronics retailers, pharmacies, building-material suppliers, and wholesale distributors use TechAssembly to keep every branch on the same record.
                  </p>
                </div>

                <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-10">
                  {[
                    {
                      href: '/use-cases/retail',
                      icon: 'M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4',
                      title: 'Retail chains',
                      tag: 'Multi-branch stock and sales',
                      text: 'Track stock across branches. See every sale as it happens. Transfers require approvals — no stock moves invisibly.',
                    },
                    {
                      icon: 'M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z',
                      title: 'Electronics retailers',
                      tag: 'High-value inventory, serial tracking',
                      text: 'Tie every checkout to stock and payment records. Know which branch has which unit without calling to ask.',
                    },
                    {
                      icon: 'M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z',
                      title: 'Pharmacies',
                      tag: 'Stock discipline, branch transfers',
                      text: 'Maintain accurate stock positions across locations. Keep an audit trail for every sale, transfer, and replenishment.',
                    },
                    {
                      icon: 'M13 16V6a1 1 0 00-1-1H4a1 1 0 00-1 1v10a1 1 0 001 1h1m8-1a1 1 0 01-1 1H9m4-1V8a1 1 0 011-1h2.586a1 1 0 01.707.293l3.414 3.414a1 1 0 01.293.707V16a1 1 0 01-1 1h-1m-6-1a1 1 0 001 1h1M5 17a2 2 0 104 0m-4 0a2 2 0 114 0m6 0a2 2 0 104 0m-4 0a2 2 0 114 0',
                      title: 'Building materials & wholesale',
                      tag: 'Bulk orders, multi-site dispatch',
                      text: 'Coordinate orders, dispatch, and payments across warehouses and project sites without losing track of what went where.',
                    },
                  ].map((card, i) => {
                    const Wrapper = card.href ? 'a' : 'div';
                    return (
                      <Wrapper
                        key={i}
                        {...(card.href ? { href: card.href } : {})}
                        className="group bg-surface-elevated rounded-lg p-8 border border-border-primary hover:border-accent/50 transition-all duration-300 block"
                      >
                        <div className="w-12 h-12 rounded-md bg-brand-orange flex items-center justify-center mb-6 group-hover:scale-105 transition-transform shadow-sm">
                          <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d={card.icon} />
                          </svg>
                        </div>
                        <h3 className="text-lg font-bold text-text-primary mb-2">{card.title}</h3>
                        <p className="text-xs text-text-tertiary mb-4 font-medium tracking-wide uppercase">{card.tag}</p>
                        <p className="text-sm text-text-secondary leading-relaxed">{card.text}</p>
                        {card.href && <span className="inline-block mt-4 text-xs font-semibold text-accent">Learn more →</span>}
                      </Wrapper>
                    );
                  })}
                </div>
              </div>
            </section>

            {/* FAQ Section */}
            <section id="faqs" className="py-24 bg-surface-primary border-t border-border-primary">
              <div className="container mx-auto px-6 max-w-4xl">
                <div className="text-center mb-16">
                  <h2 className="text-3xl md:text-4xl font-extrabold text-text-primary mb-4 tracking-tight">Common Questions</h2>
                  <p className="text-base md:text-lg text-text-tertiary font-medium">
                    Everything you need to know before getting started.
                  </p>
                </div>
                <div className="space-y-4">
                  {faqs.map((faq, i) => (
                    <div key={i} className="group border border-border-primary rounded-lg bg-surface-secondary overflow-hidden transition-all hover:border-accent">
                      <details className="group">
                        <summary className="flex justify-between items-center font-medium cursor-pointer list-none p-6 text-lg text-text-primary">
                          <span>{faq.q}</span>
                          <span className="transition group-open:rotate-180">
                            <svg fill="none" height="24" shapeRendering="geometricPrecision" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" viewBox="0 0 24 24" width="24"><path d="M6 9l6 6 6-6"></path></svg>
                          </span>
                        </summary>
                        <div className="text-text-secondary px-6 pb-6 pt-0 leading-relaxed">
                          {faq.a}
                        </div>
                      </details>
                    </div>
                  ))}
                </div>
              </div>
            </section>

            {/* Final CTA */}
            <section className="py-24 bg-surface-secondary relative overflow-hidden">
              <div className="absolute top-0 left-1/3 w-96 h-96 bg-blue-500/10 dark:bg-blue-500/5 rounded-full blur-3xl" />
              <div className="absolute bottom-0 right-1/3 w-96 h-96 bg-purple-500/10 dark:bg-purple-500/5 rounded-full blur-3xl" />
              <div className="container mx-auto px-6 max-w-3xl text-center relative z-10">
                <h2 className="text-3xl md:text-5xl font-extrabold text-text-primary mb-6 leading-tight tracking-tight">
                  Stop running your business on chats.<br />
                  <span className="text-accent">Start running it on a system.</span>
                </h2>
                <p className="text-base md:text-lg text-text-tertiary mb-8 max-w-xl mx-auto font-medium">
                  Operational infrastructure for businesses that are serious about what comes next.
                </p>
                <AuthFlowLink className="inline-flex items-center px-7 py-3.5 bg-cta hover:bg-cta-hover text-cta-text font-semibold rounded-md text-base transition shadow-sm mb-6">
                  Get started free
                </AuthFlowLink>
                <p className="text-xs text-text-tertiary/60">
                  Free to start. No card required. Your first workflow takes under ten minutes.
                </p>
              </div>
            </section>
          </div>
        </main>
      </div>

      {/* ---------- Footer ---------- */}
      <footer className="bg-[#141414] text-white py-20 border-t border-white/10">
        <div className="container px-6 mx-auto max-w-7xl">
          <div className="flex flex-col md:flex-row justify-between items-start gap-12 mb-16">
            {/* Brand Column */}
            <div className="max-w-xs">
              <div className="flex items-center mb-6">
                <LogoSVG className="w-6 h-6 mr-3 text-white" />
                <span className="text-xl font-bold font-inter tracking-tight">TechAssembly</span>
              </div>
              <p className="text-gray-400 leading-relaxed mb-6">
                Orders, stock, payments, approvals — one system for your whole business.
              </p>
              <AuthFlowLink className="inline-block text-white font-medium border-b border-white pb-0.5 hover:opacity-80 transition-opacity">
                Get Started
              </AuthFlowLink>
            </div>

            {/* Links Grid */}
            <div className="flex-1 grid grid-cols-2 md:grid-cols-5 gap-8 md:gap-10">
              <div>
                <h4 className="text-lg font-bold mb-6 text-white">Company</h4>
                <ul className="space-y-4 text-gray-400">
                  <li><a href="/company" className="hover:text-white transition-colors">About Us</a></li>
                  <li><a href="/science" className="hover:text-white transition-colors">Our Science</a></li>
                  <li><a href="https://blog.techassembly.io" target="_blank" rel="noreferrer" className="hover:text-white transition-colors">Blog</a></li>
                  <li><a href="/support/contact-us" className="hover:text-white transition-colors">Contact</a></li>
                </ul>
              </div>
              <div>
                <h4 className="text-lg font-bold mb-6 text-white">Platform</h4>
                <ul className="space-y-4 text-gray-400">
                  <li><a href="/pricing" className="hover:text-white transition-colors">Pricing</a></li>
                  <li><a href="/#how-it-works" className="hover:text-white transition-colors">How It Works</a></li>
                  <li><a href="/smart-forms" className="hover:text-white transition-colors">Inputs & Forms</a></li>
                  <li><a href="/whatsapp-automation" className="hover:text-white transition-colors">WhatsApp</a></li>
                  <li><a href="/ai-powered-business-profile" className="hover:text-white transition-colors">Profiles & SEO</a></li>
                </ul>
              </div>
              <div>
                <h4 className="text-lg font-bold mb-6 text-white">Use Cases</h4>
                <ul className="space-y-4 text-gray-400">
                  <li><a href="/use-cases/retail" className="hover:text-white transition-colors">Retail Operations</a></li>
                  <li><a href="/use-cases/logistics" className="hover:text-white transition-colors">Logistics & Distribution</a></li>
                  <li><a href="/use-cases/field-operations" className="hover:text-white transition-colors">Field Operations</a></li>
                </ul>
              </div>
              <div>
                <h4 className="text-lg font-bold mb-6 text-white">Get Started</h4>
                <ul className="space-y-4 text-gray-400">
                  <li><AuthFlowLink className="hover:text-white transition-colors">Create Profile</AuthFlowLink></li>
                  <li><AuthFlowLink className="hover:text-white transition-colors">Login</AuthFlowLink></li>
                  <li><a href="/#faqs" className="hover:text-white transition-colors">FAQs</a></li>
                </ul>
              </div>
              <div>
                <h4 className="text-lg font-bold mb-6 text-white">Legal</h4>
                <ul className="space-y-4 text-gray-400">
                  <li><a href="/privacy" className="hover:text-white transition-colors">Privacy</a></li>
                  <li><a href="/terms" className="hover:text-white transition-colors">Terms</a></li>
                  <li><a href="/cookies" className="hover:text-white transition-colors">Cookies</a></li>
                </ul>
              </div>
            </div>
          </div>

          <hr className="border-none border-t border-white/[0.07] mt-0" />

          <div className="py-8 flex flex-wrap items-center justify-between gap-6">
            <div className="flex flex-wrap items-center divide-x divide-white/[0.08]">
              <div className="flex items-center gap-3 px-5 first:pl-0">
                <div className="w-8 h-8 rounded-lg bg-white/[0.06] flex items-center justify-center flex-shrink-0">
                  <svg className="w-3.5 h-3.5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2">
                    <rect x="2" y="4" width="20" height="16" rx="2" />
                    <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
                  </svg>
                </div>
                <div>
                  <p className="text-[10px] font-semibold tracking-widest uppercase text-white/30 mb-0.5">Email</p>
                  <a href="mailto:hello@techassembly.io" className="text-sm text-gray-300 hover:text-white transition-colors">hello@techassembly.io</a>
                </div>
              </div>
              <div className="flex items-center gap-3 px-5">
                <div className="w-8 h-8 rounded-lg bg-white/[0.06] flex items-center justify-center flex-shrink-0">
                  <svg className="w-3.5 h-3.5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2">
                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.77 1h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 8.91a16 16 0 0 0 5.91 5.91l.87-.87a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" />
                  </svg>
                </div>
                <div>
                  <p className="text-[10px] font-semibold tracking-widest uppercase text-white/30 mb-0.5">Phone</p>
                  <a href="tel:+2348029056826" className="text-sm text-gray-300 hover:text-white transition-colors">+234 802 905 6826</a>
                </div>
              </div>
              <div className="flex items-center gap-3 px-5">
                <div className="w-8 h-8 rounded-lg bg-white/[0.06] flex items-center justify-center flex-shrink-0">
                  <svg className="w-3.5 h-3.5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2">
                    <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                    <circle cx="12" cy="10" r="3" />
                  </svg>
                </div>
                <div>
                  <p className="text-[10px] font-semibold tracking-widest uppercase text-white/30 mb-0.5">Address</p>
                  <p className="text-sm text-gray-300">2nd Floor,Blk 504 MQ, Kodesoh St, Ikeja, Lagos</p>
                </div>
              </div>
            </div>

            <div className="flex items-center gap-2.5 bg-blue-500/[0.08] border border-blue-500/20 rounded-full px-4 py-2">
              <svg className="w-4 h-4 flex-shrink-0" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2z" fill="#1877F2" />
                <path d="M9 11.5l2 2 4-4" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
              <span className="text-xs text-white/50">
                <span className="text-blue-400 font-medium">Meta verified</span> Tech Provider
              </span>
            </div>
          </div>

          <hr className="border-none border-t border-white/[0.07] mt-0" />

          <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-6">
            <div className="flex items-center gap-6">
              <a href="https://www.linkedin.com/company/techassembly-co" target="_blank" rel="noreferrer" className="p-2 bg-white/10 rounded-lg hover:bg-white/20 transition-colors">
                <LinkedInIcon className="w-5 h-5 text-white" />
              </a>
              <a href="https://x.com/TechAssemblyCo" target="_blank" rel="noreferrer" className="p-2 bg-white/10 rounded-lg hover:bg-white/20 transition-colors">
                <XIcon className="w-5 h-5 text-white" />
              </a>
              <a href="https://facebook.com/TechAssemblyCo" target="_blank" rel="noreferrer" className="p-2 bg-white/10 rounded-lg hover:bg-white/20 transition-colors">
                <FacebookIcon className="w-5 h-5 text-white" />
              </a>
            </div>
            <div className="flex items-center gap-6 text-sm text-gray-400">
              <a href="/privacy" className="hover:text-white transition-colors">Privacy</a>
              <a href="/terms" className="hover:text-white transition-colors">Terms</a>
              <a href="/cookies" className="hover:text-white transition-colors">Cookies</a>
            </div>
            <div className="text-sm text-gray-600">
              &copy; {new Date().getFullYear()} TechAssembly Ltd. All rights reserved.
            </div>
          </div>
        </div>
      </footer>

      {/* Cookie Consent Banner */}
      <div
        id="cookie-banner"
        className={`fixed bottom-0 left-0 right-0 z-[100] bg-surface-elevated border-t border-border-primary shadow-lg transform transition-transform duration-300 ${cookieVisible ? 'translate-y-0' : 'translate-y-full'}`}
        style={{ display: cookieVisible ? 'block' : 'none' }}
      >
        <div className="max-w-7xl mx-auto px-6 py-4 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-text-secondary">
            We use cookies to enhance your experience and analyse site traffic. <a href="/privacy" className="underline hover:text-text-primary">Learn more</a>.
          </p>
          <div className="flex items-center gap-3">
            <button onClick={declineCookies} className="text-sm text-text-tertiary hover:text-text-secondary transition-colors">Decline</button>
            <button onClick={acceptCookies} className="px-4 py-2 bg-cta hover:bg-cta-hover text-cta-text text-sm font-medium rounded-md transition">Accept</button>
          </div>
        </div>
      </div>

      {/* Global layout styles from public.html.heex */}
      <style>{`
        .navbar {
          height: 44px;
          backdrop-filter: blur(16px);
          -webkit-backdrop-filter: blur(16px);
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          background-color: color-mix(in srgb, var(--surface-elevated) 85%, transparent);
          border-bottom: 1px solid var(--border-primary);
        }
        .navbar.scrolled {
          background-color: color-mix(in srgb, var(--surface-elevated) 95%, transparent);
          box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
        }
        .nav-link {
          position: relative;
          font-weight: 500;
          font-size: 0.8125rem;
          padding: 0.375rem 0.625rem;
          border-radius: 6px;
          transition: all 0.2s ease;
          color: var(--text-secondary);
        }
        .nav-link:hover {
          background-color: var(--accent-subtle);
          color: var(--accent-text);
        }
        .mobile-menu {
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          backdrop-filter: blur(16px);
          -webkit-backdrop-filter: blur(16px);
          background-color: color-mix(in srgb, var(--surface-elevated) 95%, transparent);
          border: 1px solid var(--border-primary);
          box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
        }
        .profile-menu {
          backdrop-filter: blur(16px);
          -webkit-backdrop-filter: blur(16px);
          background-color: color-mix(in srgb, var(--surface-elevated) 95%, transparent);
          border: 1px solid var(--border-primary);
          box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
        }
        .btn-primary {
          background: var(--cta-primary);
          color: var(--cta-primary-text);
          font-weight: 600;
          padding: 0.4375rem 1rem;
          font-size: 0.8125rem;
          border-radius: 6px;
          transition: all 0.2s ease;
          box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
        }
        .btn-primary:hover {
          background: var(--cta-primary-hover);
        }
      `}</style>
    </div>
  );
}

/* ------------------------------------------------------------------
   SVG mockups for the "How It Works" section
   ------------------------------------------------------------------ */

function StepSVG({ step }: { step: number }) {
  if (step === 0) {
    return (
      <svg width="100%" viewBox="0 0 480 220" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="Storefront mockup">
        <rect width="480" height="220" rx="8" style={{ fill: 'var(--surface-secondary)' }} />
        <rect width="480" height="28" rx="8" style={{ fill: 'var(--surface-elevated)' }} />
        <circle cx="14" cy="14" r="3.5" fill="#ff5f57" />
        <circle cx="24" cy="14" r="3.5" fill="#febc2e" />
        <circle cx="34" cy="14" r="3.5" fill="#28c840" />
        <rect x="50" y="7" width="200" height="14" rx="7" style={{ fill: 'var(--surface-primary)' }} />
        <text x="150" y="18" fontSize="7" textAnchor="middle" fontFamily="monospace" style={{ fill: 'var(--text-tertiary)' }}>techassembly.io/@eji-store</text>
        <rect x="0" y="28" width="80" height="192" style={{ fill: 'var(--surface-elevated)' }} />
        <circle cx="40" cy="56" r="14" fill="#EA580C" />
        <text x="40" y="61" fontSize="10" fontWeight="bold" textAnchor="middle" fill="white">E</text>
        <rect x="12" y="78" width="56" height="5" rx="2.5" style={{ fill: 'var(--text-secondary)', opacity: 0.5 }} />
        <rect x="12" y="92" width="56" height="4" rx="2" style={{ fill: 'var(--text-tertiary)', opacity: 0.3 }} />
        <rect x="12" y="104" width="40" height="4" rx="2" style={{ fill: 'var(--text-tertiary)', opacity: 0.3 }} />
        {[90, 220, 350].map((x, i) => (
          <g key={i}>
            <rect x={x} y="38" width="120" height="80" rx="6" style={{ fill: 'var(--surface-elevated)', stroke: 'var(--border-primary)' }} strokeWidth="1" />
            <rect x={x} y="38" width="120" height="48" rx="6" fill={['#1e3a5f', '#1a3a2a', '#2e1a3a'][i]} />
            <rect x={x + 8} y="96" width="60" height="5" rx="2.5" style={{ fill: 'var(--text-secondary)', opacity: 0.6 }} />
            <rect x={x + 8} y="106" width="32" height="4" rx="2" fill="#EA580C" opacity="0.9" />
          </g>
        ))}
        {[90, 220, 350].map((x, i) => (
          <g key={i}>
            <rect x={x} y="128" width="120" height="80" rx="6" style={{ fill: 'var(--surface-elevated)', stroke: 'var(--border-primary)' }} strokeWidth="1" />
            <rect x={x} y="128" width="120" height="48" rx="6" fill={['#3a2a10', '#1a2f3a', '#2a1a1a'][i]} />
            <rect x={x + 8} y="186" width="60" height="5" rx="2.5" style={{ fill: 'var(--text-secondary)', opacity: 0.6 }} />
          </g>
        ))}
      </svg>
    );
  }
  if (step === 1) {
    return (
      <svg width="100%" viewBox="0 0 480 220" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="Workflow builder mockup">
        <rect width="480" height="220" rx="8" style={{ fill: 'var(--surface-secondary)' }} />
        <rect width="480" height="32" rx="8" style={{ fill: 'var(--surface-elevated)' }} />
        <text x="16" y="21" fontSize="10" fontWeight="600" fontFamily="sans-serif" style={{ fill: 'var(--text-primary)' }}>Workflow Builder</text>
        <rect x="370" y="9" width="48" height="14" rx="4" fill="#EA580C" />
        <text x="394" y="19" fontSize="7" textAnchor="middle" fill="white" fontFamily="sans-serif">Publish</text>
        <rect x="40" y="52" width="120" height="44" rx="8" style={{ fill: 'var(--surface-elevated)', stroke: 'var(--border-primary)' }} strokeWidth="1" />
        <rect x="48" y="58" width="40" height="10" rx="4" fill="#DBEAFE" />
        <text x="68" y="66" fontSize="6" textAnchor="middle" fontWeight="600" fill="#1D4ED8" fontFamily="sans-serif">TRIGGER</text>
        <text x="48" y="84" fontSize="8" fontWeight="500" fontFamily="sans-serif" style={{ fill: 'var(--text-primary)' }}>Order Placed</text>
        <line x1="160" y1="74" x2="190" y2="74" strokeWidth="1.5" style={{ stroke: 'var(--border-primary)' }} />
        <polygon points="188,70 196,74 188,78" style={{ fill: 'var(--border-primary)' }} />
        <rect x="196" y="52" width="120" height="44" rx="8" style={{ fill: 'var(--surface-elevated)', stroke: 'var(--border-primary)' }} strokeWidth="1" />
        <rect x="204" y="58" width="38" height="10" rx="4" fill="#DCFCE7" />
        <text x="223" y="66" fontSize="6" textAnchor="middle" fontWeight="600" fill="#16A34A" fontFamily="sans-serif">ACTION</text>
        <text x="204" y="84" fontSize="8" fontWeight="500" fontFamily="sans-serif" style={{ fill: 'var(--text-primary)' }}>Reserve Stock</text>
        <line x1="316" y1="74" x2="346" y2="74" strokeWidth="1.5" style={{ stroke: 'var(--border-primary)' }} />
        <polygon points="344,70 352,74 344,78" style={{ fill: 'var(--border-primary)' }} />
        <rect x="352" y="52" width="120" height="44" rx="8" style={{ fill: 'var(--surface-elevated)', stroke: 'var(--border-primary)' }} strokeWidth="1" />
        <rect x="360" y="58" width="38" height="10" rx="4" fill="#DCFCE7" />
        <text x="379" y="66" fontSize="6" textAnchor="middle" fontWeight="600" fill="#16A34A" fontFamily="sans-serif">ACTION</text>
        <text x="360" y="84" fontSize="8" fontWeight="500" fontFamily="sans-serif" style={{ fill: 'var(--text-primary)' }}>Notify Customer</text>
        <line x1="256" y1="96" x2="256" y2="120" strokeWidth="1.5" style={{ stroke: 'var(--border-primary)' }} />
        <polygon points="252,118 256,126 260,118" style={{ fill: 'var(--border-primary)' }} />
        <rect x="196" y="126" width="120" height="44" rx="8" style={{ fill: 'var(--surface-elevated)', stroke: 'var(--border-primary)' }} strokeWidth="1" />
        <rect x="204" y="132" width="28" height="10" rx="4" fill="#FEF3C7" />
        <text x="218" y="140" fontSize="6" textAnchor="middle" fontWeight="600" fill="#B45309" fontFamily="sans-serif">WAIT</text>
        <text x="204" y="158" fontSize="8" fontWeight="500" fontFamily="sans-serif" style={{ fill: 'var(--text-primary)' }}>Await Approval</text>
        <line x1="316" y1="148" x2="346" y2="148" strokeWidth="1.5" style={{ stroke: 'var(--border-primary)' }} />
        <polygon points="344,144 352,148 344,152" style={{ fill: 'var(--border-primary)' }} />
        <rect x="352" y="126" width="120" height="44" rx="8" style={{ fill: 'var(--surface-elevated)', stroke: 'var(--border-primary)' }} strokeWidth="1" />
        <rect x="360" y="132" width="28" height="10" rx="4" fill="#EDE9FE" />
        <text x="374" y="140" fontSize="6" textAnchor="middle" fontWeight="600" fill="#7C3AED" fontFamily="sans-serif">EMIT</text>
        <text x="360" y="158" fontSize="8" fontWeight="500" fontFamily="sans-serif" style={{ fill: 'var(--text-primary)' }}>Order Fulfilled</text>
        <text x="240" y="198" fontSize="8" textAnchor="middle" fontFamily="sans-serif" style={{ fill: 'var(--text-tertiary)' }}>Describe what you need in plain English — the AI builds it.</text>
      </svg>
    );
  }
  return (
    <svg width="100%" viewBox="0 0 480 220" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="Command center mockup">
      <rect width="480" height="220" rx="8" style={{ fill: 'var(--surface-secondary)' }} />
      <rect width="480" height="32" rx="8" style={{ fill: 'var(--surface-elevated)' }} />
      <text x="16" y="21" fontSize="10" fontWeight="600" fontFamily="sans-serif" style={{ fill: 'var(--text-primary)' }}>Command Centre</text>
      <circle cx="440" cy="16" r="3" fill="#22C55E" />
      <text x="450" y="19" fontSize="8" fontFamily="sans-serif" style={{ fill: 'var(--text-tertiary)' }}>Live</text>
      <line x1="160" y1="32" x2="160" y2="220" strokeWidth="1" style={{ stroke: 'var(--border-primary)' }} />
      <line x1="320" y1="32" x2="320" y2="220" strokeWidth="1" style={{ stroke: 'var(--border-primary)' }} />
      <text x="12" y="48" fontSize="7" fontWeight="600" fontFamily="sans-serif" style={{ fill: 'var(--text-tertiary)' }} letterSpacing="0.05em">SIGNALS</text>
      <rect x="8" y="56" width="144" height="32" rx="4" style={{ fill: 'var(--surface-elevated)', stroke: 'var(--border-primary)' }} strokeWidth="0.5" />
      <rect x="8" y="56" width="2" height="32" rx="1" fill="#DC2626" />
      <text x="16" y="68" fontSize="6" fontWeight="600" fill="#DC2626" fontFamily="sans-serif">CRITICAL</text>
      <text x="16" y="80" fontSize="7" fontFamily="sans-serif" style={{ fill: 'var(--text-primary)' }}>Delivery unconfirmed</text>
      <rect x="8" y="94" width="144" height="32" rx="4" style={{ fill: 'var(--surface-elevated)', stroke: 'var(--border-primary)' }} strokeWidth="0.5" />
      <rect x="8" y="94" width="2" height="32" rx="1" fill="#D97706" />
      <text x="16" y="106" fontSize="6" fontWeight="600" fill="#B45309" fontFamily="sans-serif">WARNING</text>
      <text x="16" y="118" fontSize="7" fontFamily="sans-serif" style={{ fill: 'var(--text-primary)' }}>Workflow stalled 24h</text>
      <rect x="8" y="132" width="144" height="32" rx="4" style={{ fill: 'var(--surface-elevated)', stroke: 'var(--border-primary)' }} strokeWidth="0.5" />
      <rect x="8" y="132" width="2" height="32" rx="1" fill="#3B82F6" />
      <text x="16" y="144" fontSize="6" fontWeight="600" fill="#2563EB" fontFamily="sans-serif">INFO</text>
      <text x="16" y="156" fontSize="7" fontFamily="sans-serif" style={{ fill: 'var(--text-primary)' }}>Payment: ₦28,000</text>
      <text x="168" y="48" fontSize="7" fontWeight="600" fontFamily="sans-serif" style={{ fill: 'var(--text-tertiary)' }} letterSpacing="0.05em">OPS MAP</text>
      <rect x="168" y="56" width="144" height="48" rx="4" style={{ fill: 'var(--surface-elevated)', stroke: 'var(--border-primary)' }} strokeWidth="0.5" />
      <rect x="174" y="62" width="34" height="10" rx="4" fill="rgba(234,88,12,0.08)" />
      <text x="178" y="70" fontSize="6" fontWeight="600" fill="#EA580C" fontFamily="sans-serif">BLOCKED</text>
      <text x="174" y="86" fontSize="7.5" fontWeight="500" fontFamily="sans-serif" style={{ fill: 'var(--text-primary)' }}>Generic Approval</text>
      <circle cx="174" cy="96" r="3" fill="#22C55E" />
      <circle cx="184" cy="96" r="3" fill="#D97706" />
      <circle cx="194" cy="96" r="3" style={{ fill: 'var(--border-primary)' }} />
      <rect x="168" y="110" width="144" height="48" rx="4" style={{ fill: 'var(--surface-elevated)', stroke: 'var(--border-primary)' }} strokeWidth="0.5" />
      <rect x="174" y="116" width="40" height="10" rx="4" fill="rgba(22,163,74,0.07)" />
      <text x="178" y="124" fontSize="6" fontWeight="600" fill="#16A34A" fontFamily="sans-serif">RUNNING</text>
      <text x="174" y="140" fontSize="7.5" fontWeight="500" fontFamily="sans-serif" style={{ fill: 'var(--text-primary)' }}>Sales Order Fulfilment</text>
      <circle cx="174" cy="150" r="3" fill="#22C55E" />
      <circle cx="184" cy="150" r="3" fill="#22C55E" />
      <circle cx="194" cy="150" r="3" fill="#3B82F6" />
      <circle cx="204" cy="150" r="3" style={{ fill: 'var(--border-primary)' }} />
      <text x="328" y="48" fontSize="7" fontWeight="600" fontFamily="sans-serif" style={{ fill: 'var(--text-tertiary)' }} letterSpacing="0.05em">DECISIONS</text>
      <rect x="328" y="56" width="144" height="40" rx="4" style={{ fill: 'var(--surface-elevated)', stroke: 'var(--border-primary)' }} strokeWidth="0.5" />
      <text x="336" y="70" fontSize="7" fontWeight="500" fontFamily="sans-serif" style={{ fill: 'var(--text-primary)' }}>Inter-branch transfer</text>
      <text x="336" y="82" fontSize="6.5" fontFamily="sans-serif" style={{ fill: 'var(--text-secondary)' }}>Lagos → Abuja · 12 units</text>
      <rect x="440" y="62" width="14" height="14" rx="3" fill="#DCFCE7" />
      <text x="447" y="73" fontSize="9" textAnchor="middle" fill="#16A34A" fontFamily="sans-serif">✓</text>
      <rect x="456" y="62" width="14" height="14" rx="3" fill="#FEF2F2" />
      <text x="463" y="73" fontSize="9" textAnchor="middle" fill="#DC2626" fontFamily="sans-serif">✕</text>
      <rect x="328" y="102" width="144" height="40" rx="4" style={{ fill: 'var(--surface-elevated)', stroke: 'var(--border-primary)' }} strokeWidth="0.5" />
      <text x="336" y="116" fontSize="7" fontWeight="500" fontFamily="sans-serif" style={{ fill: 'var(--text-primary)' }}>Expense approval</text>
      <text x="336" y="128" fontSize="6.5" fontFamily="sans-serif" style={{ fill: 'var(--text-secondary)' }}>₦45,000 · Office supplies</text>
      <rect x="440" y="108" width="14" height="14" rx="3" fill="#DCFCE7" />
      <text x="447" y="119" fontSize="9" textAnchor="middle" fill="#16A34A" fontFamily="sans-serif">✓</text>
      <rect x="456" y="108" width="14" height="14" rx="3" fill="#FEF2F2" />
      <text x="463" y="119" fontSize="9" textAnchor="middle" fill="#DC2626" fontFamily="sans-serif">✕</text>
    </svg>
  );
}
